import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d05c5df6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-download-file" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-download-file" }, null, -1))
const _hoisted_3 = ["href", "download"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-download-file" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logo-circle" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-move-folder" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-copy-content" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-trash" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_solo_case_selector = _resolveComponent("app-solo-case-selector")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_app_skeleton_case_view = _resolveComponent("app-skeleton-case-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_bottom_pop_up, {
      onHide: _ctx.hidePopUp,
      "hide-bottom-decoration": "",
      "hide-top-decoration": ""
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.isPhoto ? _ctx.$localize('media.settings.popup.title.type.photo') : _ctx.$localize('media.settings.popup.title.type.file')), 1)
      ]),
      body: _withCtx(() => [
        (_ctx.mainStore.isNative)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadMedia && _ctx.downloadMedia(...args))),
              href: "javascript:void(0);",
              class: "link"
            }, [
              _createVNode(_component_bottom_pop_up_item, null, {
                icon: _withCtx(() => [
                  _hoisted_1
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.download')) + " ", 1)
                ]),
                _: 1
              })
            ]))
          : (_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadMediaFlutter && _ctx.downloadMediaFlutter(...args))),
                href: "javascript:void(0);",
                class: "link"
              }, [
                _createVNode(_component_bottom_pop_up_item, null, {
                  icon: _withCtx(() => [
                    _hoisted_2
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.download')) + " ", 1)
                  ]),
                  _: 1
                })
              ]))
            : (_ctx.mainStore.isMobile || !_ctx.mainStore.isResponsive)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: _ctx.downloadUrl,
                  download: _ctx.file.name,
                  class: "link"
                }, [
                  _createVNode(_component_bottom_pop_up_item, null, {
                    icon: _withCtx(() => [
                      _hoisted_4
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.download')) + " ", 1)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_3))
              : _createCommentVNode("", true),
        (!_ctx.isNetwork && _ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 3,
              onClick: _ctx.onRename
            }, {
              icon: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.rename.option')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isNetwork && _ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 4,
              onClick: _ctx.openMovePopUp
            }, {
              icon: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.move')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.allowSave)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 5,
              onClick: _ctx.saveMediaAsCopy
            }, {
              icon: _withCtx(() => [
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.copy')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isNetwork && !_ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 6,
              onClick: _ctx.removeSharing
            }, {
              icon: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.remove.sharing')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isNetwork && _ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 7,
              onClick: _ctx.deleteMedia
            }, {
              icon: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.delete')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isNetwork && _ctx.isMy && _ctx.mainStore.isMobile)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 8,
              onClick: _ctx.onInfo
            }, {
              icon: _withCtx(() => [
                _hoisted_10
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('photo.view.info')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.caseSelector)
          ? (_openBlock(), _createBlock(_component_app_solo_case_selector, {
              key: 9,
              title: "Add to Case",
              onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.caseSelector = false)),
              onDone: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addMediaToCase($event)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onHide"]),
    (_ctx.caseViewSkeleton)
      ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
          key: 0,
          title: _ctx.skeletonCase.title,
          photoSkeletons: _ctx.skeletonCase.photosAmount,
          fileSkeletons: _ctx.skeletonCase.filesAmount
        }, null, 8, ["title", "photoSkeletons", "fileSkeletons"]))
      : _createCommentVNode("", true)
  ], 64))
}